"use client";

import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { Spinner } from "./ui/shadcn-io/spinner";

function RouteLoader() {
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [pathname]);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center backdrop-blur-xl z-50">
      <Spinner variant="circle" />
    </div>
  );
}

export default RouteLoader;
